/* tslint:disable */
/* eslint-disable */
export enum TourStatus {
  Open = 'open',
  Sent = 'sent',
  Closed = 'closed'
}
